import { Button, DownloadIcon } from "melco-ui";
import { useDownloadReports } from "../../../hooks/reporting/statistics/useDownloadReports";
import { saveAs } from "file-saver";

type DownloadReportsButtonProps = {
  dataConfig: any;
  disabled?: boolean;
};
export const DownloadReportsButton: React.FC<DownloadReportsButtonProps> = ({
  dataConfig,
  disabled,
}) => {
  const [downloadReports, isLoading] = useDownloadReports(dataConfig);

  return (
    <>
      <Button
        size="small"
        icon={<DownloadIcon />}
        onClick={async () => {
          const response = await downloadReports();
          if (
            response?.blob &&
            response?.filename &&
            response?.filename !== ""
          ) {
            saveAs(response?.blob, response?.filename);
          } else {
            console.log("It is not blob or Invalid filename");
          }
        }}
        loading={isLoading}
        disabled={disabled}
      >
        .csv
      </Button>
    </>
  );
};
